import React from "react";
import { Button, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

const ProcesoCompleto = () => {
  return (
    <>
      <Container fluid className="background-containerr">
        <div className="container text-center">
          <div className="row">
            <div className="col">
              <div className="TituloPrincipal">
                <br /> <h1>Proceso Completo IT</h1>
              </div>
              <center>
                <hr className="linea-horizontal"></hr>
              </center>
            </div>
            <div className="col">
              <div className="Text_Buttons_Radio_buttons">
              </div>
            </div>
          </div>
        </div>

        <div class="table-container">
          <table class="styled-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Nombre Del Proceso</th>
                <th>Descripción</th>
                <th>Documentación</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>
                  <p>
                    <b>Proceso Comercial IT</b>
                  </p>
                </td>
                <td>
                  <p>
                    El propósito principal de tener un proceso comercial completo 
                    es garantizar la entrega eficiente, rentable y con alta calidad 
                    de los servicios ofrecidos, asegurando una experiencia positiva 
                    y continua para el cliente a lo largo de todo el ciclo de vida 
                    del proyecto. Desde el primer contacto en preventa hasta el 
                    seguimiento postventa, este proceso permite alinear los esfuerzos 
                    de las áreas comerciales, técnicas y operativas bajo un mismo 
                    enfoque ágil, escalable y medible.
                  </p>
                </td>
                <td>

                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/proceso-completo-it/proceso-comercial-completo"
                  >
                    Procedimiento
                  </Button>

                </td>
              </tr>
              <tr>
                <td>2</td>
                <td>
                  <p>
                    <b>01 Generación de Demanda Omnicanal</b>
                  </p>
                </td>
                <td>
                  <p>
                    El proceso de generación de demanda 
                    omnicanal busca atraer y convertir prospectos de múltiples 
                    canales (digitales, físicos, directos e indirectos), 
                    asegurando una experiencia unificada, personalizada y continua.
                  </p>
                </td>
                <td>

                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/proceso-completo-it/generacion-demanda-omnicanal"
                  >
                    Procedimiento
                  </Button>

                </td>
              </tr>
              <tr>
                <td>3</td>
                <td>
                  <p>
                    <b>02 Asignación de Cuentas y Segmentación de Oportunidades</b>
                  </p>
                </td>
                <td>
                  <p>
                    Organizar y distribuir las cuentas y oportunidades 
                    de forma estratégica para maximizar el potencial de cierre y la atención 
                    personalizada. Asegurando que los Ejecutivos de cuenta o consultores 
                    trabajen con las oportunidades correctas, en función de su perfil, 
                    experiencia, maximizando la conversión y atención efectiva.
                  </p>
                </td>
                <td>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/proceso-completo-it/asignacion-cuentas-segmentacion-oportunidades"
                  >
                    Procedimiento
                  </Button>
                </td>
              </tr>
              <tr>
                <td>4</td>
                <td>
                  <p>
                    <b>03 Análisis de Requerimientos</b>
                  </p>
                </td>
                <td>
                  <p>
                    Levantar información precisa sobre las necesidades 
                    del cliente para dimensionar correctamente el proyecto desde el inicio. 
                    Evitando desviaciones que afecten los tiempos, presupuesto o calidad de 
                    entrega, y asegurar que el cliente reciba lo que realmente necesita.
                  </p>
                </td>
                <td>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/proceso-completo-it/analisis-requerimientos"
                  >
                    Procedimiento
                  </Button>
                </td>
              </tr>
              <tr>
                <td>5</td>
                <td>
                  <p>
                    <b>04 Diseño de Solución y Propuesta Técnico-Comercial</b>
                  </p>
                </td>
                <td>
                  <p>
                    Transformar los requerimientos en una solución 
                    concreta con arquitectura, servicios, tiempos y costos definidos. 
                    Garantizando que lo ofrecido al cliente sea ejecutable, rentable y 
                    cumpla con las expectativas.
                  </p>
                </td>
                <td>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/proceso-completo-it/disenio-solucion-propuesta-tecnico-comercial"
                  >
                    Procedimiento
                  </Button>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/proceso-completo-it/disenio-solucion-propuesta-tecnico-comercial-raci"
                  >
                    Matriz RACI
                  </Button>
                </td>
              </tr>
              <tr>
                <td>6</td>
                <td>
                  <p>
                    <b>06 Fase de Negociación y Cierre</b>
                  </p>
                </td>
                <td>
                  <p>
                    Lograr la aceptación formal  del cliente y la firma del contrato
                  </p>
                </td>
                <td>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/proceso-completo-it/fase-negociacion-cierre"
                  >
                    Procedimiento
                  </Button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Container>
    </>
  );
};

export default ProcesoCompleto;

// https://app.diagrams.net/#G1HJo4V6_lXFNTb4mwHiA1kvTAdCy4tg1F
